import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import { IconName } from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';

export interface ButtonElement extends HTMLElement {
  block?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'text';
  color?: 'action' | 'destructive' | 'teal' | 'inverse-teal';
  size?: 'small' | 'medium' | 'large';
  'icon-right'?: IconName;
  'icon-left'?: IconName;
}

const OpButton = createWrapper<ButtonElement>('op-button');

export default OpButton;
